import type { ReactNode } from "react";

import { classes } from "./classes.js";

/**
 * `P0-UIK-001`. An empty list says WHY it is empty and what to do next.
 *
 * 4.6.6's failure-copy row is the same instinct one level down: *"Every
 * network error renders a French sentence and a retry control, never a spinner
 * that never ends"*. A blank panel is the silent version of that spinner.
 */
export interface EmptyStateProps {
  readonly title: ReactNode;
  readonly description?: ReactNode;
  readonly action?: ReactNode;
  /** `F-0c`: the bank draws « le veilleur » above the title; absent, nothing is drawn (the other apps pass none). */
  readonly mascot?: ReactNode;
  readonly className?: string;
}

export function EmptyState({
  title,
  description,
  action,
  mascot,
  className,
}: EmptyStateProps): React.JSX.Element {
  return (
    <div className={classes("flex flex-col items-center gap-2 p-6 text-center", className)}>
      {mascot === undefined ? null : <div className="mb-1 w-[150px]">{mascot}</div>}
      <p className="text-sm font-medium text-gray-900">{title}</p>
      {description === undefined ? null : <p className="text-xs text-gray-500">{description}</p>}
      {action === undefined ? null : <div className="mt-2">{action}</div>}
    </div>
  );
}
